export const CREATING_SETTING = "CREATING_SETTING";
export const UPDATING_SETTING = "UPDATING_SETTING";
export const SETTING_CREATED = "SETTING_CREATED";
export const SETTING_UPDATED = "SETTING_UPDATED";
export const ERROR_SETTING_CREATE = "ERROR_SETTING_CREATE";
export const ERROR_SETTING_UPDATE = "ERROR_SETTING_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
